import { useState } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faChartLine,
  faComments,
  faDatabase,
  faGear,
  faGlobe,
  faGrip,
  faRightFromBracket,
  faUser,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../context/AuthContext";
import { initials } from "../utils/format";

const nav = [
  { to: "/", label: "Dashboard", icon: faGrip, end: true },
  { to: "/websites", label: "Websites", icon: faGlobe },
  { to: "/knowledge", label: "Knowledge", icon: faDatabase },
  { to: "/chatbot", label: "Chatbot", icon: faComments },
  { to: "/analytics", label: "Analytics", icon: faChartLine },
  { to: "/settings", label: "Settings", icon: faGear },
];
const titles = {
  "/": "Dashboard",
  "/websites": "Websites",
  "/knowledge": "Knowledge",
  "/chatbot": "Chatbot",
  "/analytics": "Analytics",
  "/settings": "Settings",
  "/profile": "Admin profile",
};
export default function AppShell() {
  const [open, setOpen] = useState(false);
  const { admin, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const pageTitle =
    titles[location.pathname] ||
    (location.pathname.includes("knowledge")
      ? "Knowledge"
      : location.pathname.includes("chatbot")
        ? "Chatbot configuration"
        : location.pathname.includes("analytics")
          ? "Analytics"
          : "Website overview");
  const signOut = async () => {
    await logout();
    navigate("/login");
  };
  return (
    <div className="app-shell">
      <button
        className={`drawer-scrim ${open ? "is-open" : ""}`}
        aria-label="Close menu"
        onClick={() => setOpen(false)}
      />
      <aside className={`sidebar ${open ? "is-open" : ""}`}>
        <div className="brand">
          <span className="brand-mark">K</span>
          <div>
            <strong>FlowChat</strong>
            <small>Website intelligence</small>
          </div>
          <button
            className="mobile-close"
            onClick={() => setOpen(false)}
            aria-label="Close menu"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
        <nav>
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              onClick={() => setOpen(false)}
            >
              <FontAwesomeIcon icon={item.icon} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-bottom">
          <NavLink to="/profile" onClick={() => setOpen(false)}>
            <FontAwesomeIcon icon={faUser} />
            <span>Admin Profile</span>
          </NavLink>
          <button onClick={signOut}>
            <FontAwesomeIcon icon={faRightFromBracket} />
            <span>Logout</span>
          </button>
        </div>
      </aside>
      <div className="app-main">
        <header className="topbar">
          <button
            className="menu-button"
            onClick={() => setOpen(true)}
            aria-label="Open menu"
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
          <div>
            <span>Workspace /</span>
            <strong>{pageTitle}</strong>
          </div>
          <button className="profile-chip" onClick={() => navigate("/profile")}>
            <span className="profile-avatar">{initials(admin?.name)}</span>
            <span>
              <strong>{admin?.name}</strong>
              <small>{admin?.role || "Administrator"}</small>
            </span>
          </button>
        </header>
        <main className="content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
